import React, { lazy, Suspense } from "react";
import componentLoader from "../../utilities/componentLoader";

const Protocols = lazy(() =>
  componentLoader(() => import("./components/Protocols")),
);

export default () => (
  <div>
    <Suspense fallback={<div />}>
      <section>
        <Protocols />
      </section>
    </Suspense>
  </div>
);
